import axios from '@/axios';

const http = {
  // =========================
  // 🏠 门户首页（Portal）
  // =========================
  /**
   * 获取首页 Banner 图片列表
   */
  getBannerImg (params) {
    return axios.get('/pcs-portal/portal-external-management/acquireCarouselImageList', {
      params: {abbr: params.abbr}
    });
  },

  /**
   * 获取首页“最新资讯”列表（精简版，用于首页展示）
   */
  getNewInformation (abbr) {
    return axios.get('/pcs-portal/portal-external-management/acquireSecondPortalContentList', {
      params: {page: 1, limit: 4, abbr}
    });
  },

  /**
   * 获取首页“最新资讯”更多内容（跳转到资讯列表页）
   */
  getNewInformationMore (abbr) {
    return axios.get('/pcs-portal/portal-external-management/acquireSecondPortalRegionList', {
      params: {abbr}
    });
  },

  /**
   * 获取资讯列表（新版，用于资讯中心）
   */
  acquireSecondPortalContentListNew (abbr) {
    if (!abbr || typeof abbr !== 'string' || abbr.trim() === '') {
      return Promise.reject(new Error('abbr is required'));
    }
    return axios.get('/pcs-portal/portal-external-management/acquireSecondPortalContentListNew', {
      params: { page: 1, limit: 10, abbr: abbr.trim() }
    });
  },

  /**
   * 根据资讯 ID 获取完整内容详情
   */
  getAcquireWholeContentByContentId (id) {
    return axios.get('/pcs-portal/portal-external-management/acquireWholeContentByContentId', {
      params: {id}
    });
  },

  // =========================
  // 🔐 用户认证与信息
  // =========================
  /**
   * 获取 OAuth Token（登录）
   */
  getToken (params) {
    return axios.post('/pcs-auth/oauth/token', params);
  },

  /**
   * 根据用户名获取机构、部门信息
   */
  getInfoByUsername (params) {
    return axios.get('/pcs-consult/getTestsByUsername', {params});
  },

  /**
   * 根据用户 ID 获取被试用户信息
   */
  getTesteeByUserId (params) {
    return axios.get('/pcs-consult/getTesteeByUserId', {params});
  },

  // =========================
  // 📊 测评与量表管理（Exam & Evaluation）
  // =========================
  /**
   * 获取被试用户的测评计划列表
   */
  getPersonPlanList (userId) {
    return axios.post(`/pcs-exam/getPersonPlanList?userId=${userId}`);
  },

  /**
   * 获取测评结果（通用）
   */
  getEvaluationResult (params) {
    return axios.get('/pcs-exam/getEvaluationResult', {params});
  },

  /**
   * 获取测评详情
   */
  getPersonResultExternal (params) {
    return axios.get('/pcs-evaluation/evaluationResult/getPersonResultExternal', {params});
  },

  /**
   * 获取量表信息
   */
  getScaleInfo (params) {
    return axios.post('/pcs-exam/getScaleInfo', params);
  },

  /**
   * 保存测评基础信息
   */
  saveEvaluationInfo (params) {
    return axios.post('/pcs-exam/saveEvaluationInfo', params);
  },

  /**
   * 保存测评结果
   */
  saveEvaluationResult (params) {
    return axios.post('/pcs-exam/saveEvaluationResult', params);
  },

  /**
   * 重置密码（被试端）
   */
  resetPassword (params) {
    return axios.post('/pcs-exam/resetPassword', params);
  },

  /**
   * 下载测评报告
   */
  downloadPersonReport (params) {
    return axios.get('/pcs-evaluation/evaluationResult/downloadPersonReport', {params});
  },

  // =========================
  // 💬 咨询与问答管理（Consult）
  // =========================
  /**
   * 获取公开问题列表
   */
  getPublicQuestions (params) {
    return axios.get('/pcs-consult/getPublicQuestions', {params});
  },

  /**
   * 获取指定问题的回答列表
   */
  getAnswers (params) {
    return axios.get('/pcs-consult/getAnswers', {params});
  },

  /**
   * 获取指定回答的回复列表
   */
  getReplies (params) {
    return axios.get('/pcs-consult/getReplies', {params});
  },

  /**
   * 添加回复（原为 PUT，建议改为 POST）
   */
  addReply (params) {
    // 建议后端支持 JSON body，避免 URL 拼接敏感/长内容
    return axios.post('/pcs-consult/addReply', {
      replyContent: params.replyContent,
      answerId: params.answerId,
      responderId: params.responderId,
      responderType: '咨询者'
    });
  },

  /**
   * 获取咨询师类型列表
   */
  getCounselorType () {
    return axios.get('/pcs-consult/getCounselorType');
  },

  /**
   * 根据类型获取咨询师列表
   */
  getCounselorByType (params) {
    return axios.get('/pcs-consult/getCounselorByType', {params});
  },

  /**
   * 获取全部咨询师列表
   */
  getCounselorList (params) {
    return axios.get('/pcs-consult/getCounselorList', {params});
  },

  // =========================
  // 📅 咨询预约管理
  // =========================
  /**
   * 获取用户预约排班列表
   */
  getScheduleList (params) {
    return axios.get('/pcs-consult/getScheduleList', {params});
  },

  /**
   * 添加预约记录
   */
  getRecordAdd (params) {
    return axios.post('/pcs-consult/recordAdd', params);
  },

  /**
   * 编辑预约记录（如放弃预约）
   */
  recordEdit (params) {
    return axios.post('/pcs-consult/recordEdit', params);
  },

  /**
   * 删除预约记录
   */
  scheduleDelete (data) {
    return axios.delete('/pcs-consult/recordDelete', {
      params: {
        counselorScheduleId: data.counselorScheduleId,
        userId: data.userId
      }
    });
  },

  // =========================
  // 📺 视频课程管理（Class）
  // =========================
  /**
   * 获取视频分类列表
   */
  getVideoClassify () {
    return axios.get('/pcs-class/category/getCategories');
  },

  /**
   * 获取视频列表（按分类）
   */
  getVideoList (params) {
    return axios.get('/pcs-class/category/getVideoList', {params});
  },

  /**
   * 获取视频播放地址
   */
  getVideoDetails (params) {
    return axios.get('/pcs-class/play/getVideoUrl', {params});
  },

  // =========================
  // 📚 字典与辅助数据
  // =========================
  /**
   * 获取危机干预菜单（字典：训练类型）
   */
  getAbilityMeun () {
    return axios.get('/pcs-dict/dict/getDetails', {
      params: {dictName: '训练类型'}
    });
  },

  /**
   * 获取训练信息（来自 collect 服务）
   */
  getTrainInfo (params) {
    return axios.get('/collect/getTrainInfo', {params});
  }
};

export default http;



// WEBPACK FOOTER //
// ./src/http/index.js